import { render, staticRenderFns } from "./OrganizationsView.vue?vue&type=template&id=04271a31&"
import script from "./OrganizationsView.vue?vue&type=script&lang=js&"
export * from "./OrganizationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports